export enum BotStages {
  PetName = 'pet-name',
  PetBreed = 'pet-breed',
  PetBirthday = 'pet-birthday',
  PetWeight = 'pet-weight',
  Checkout = 'checkout',
}

export enum UserStages {
  ReplyPetName = 'reply-to-pet-name',
  ReplyPetBreed = 'reply-to-pet-breed',
  ReplyPetBirthday = 'reply-to-pet-birthday',
  ReplyPetWeight = 'reply-to-pet-weight',
}
